/* sh-collection-filters.js — native Search & Discovery filtering for collection pages.
 *
 * Reads #CollectionFiltersForm (checkboxes from collection.filters + price_range
 * inputs + sort_by select), builds a URLSearchParams from the checked/filled
 * fields and navigates. Desktop auto-submits on checkbox change; price applies
 * on Enter/blur. On mobile the form lives inside the #filters-aside drawer
 * (open/close handled by site.js) and is applied via the sticky bottom bar,
 * with a live "Toon X resultaten" count fetched from ?view=count.
 *
 * Fail-silent: the live count degrades to a static label if the fetch fails.
 * The form has a real method=get action so it works without JS too.
 */
(function () {
  var form = document.getElementById('CollectionFiltersForm');
  if (!form) return;

  var mq = window.matchMedia('(max-width: 767px)');

  /* Build a URL from the current form state (checkboxes + price + sort). */
  function buildParams() {
    var params = new URLSearchParams();
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      if (cb.name && cb.value) params.append(cb.name, cb.value);
    });
    form.querySelectorAll('input[type="number"]').forEach(function (inp) {
      if (inp.value && inp.name) params.append(inp.name, inp.value);
    });
    var sortSelect = form.querySelector('select[name="sort_by"]');
    if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);
    return params;
  }

  function apply() {
    var qs = buildParams().toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '');
  }

  /* ── Desktop: auto-submit on checkbox change, price on Enter/blur ── */
  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'checkbox' && !mq.matches) apply();
    if (t && t.name === 'sort_by') apply(); /* sort always submits, both layouts */
  });

  form.querySelectorAll('input[type="number"]').forEach(function (inp) {
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); if (!mq.matches) apply(); else updateCount(); }
    });
    inp.addEventListener('blur', function () {
      if (this.value && !mq.matches) apply();
      else if (mq.matches) updateCount();
    });
  });

  /* ── Mobile: live count + apply bar ── */
  var applyBtn = document.getElementById('sh-filters-apply');
  var clearBtn = document.getElementById('sh-filters-clear');
  var countEl = document.getElementById('sh-filters-count');
  var countDebounce;

  function updateCount() {
    if (!countEl) return;
    var params = buildParams();
    params.set('view', 'count');
    fetch(window.location.pathname + '?' + params.toString(), {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
    })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        try {
          var data = JSON.parse(t.trim());
          if (typeof data.products_count === 'number') {
            countEl.textContent = data.products_count;
            countEl.style.display = 'inline';
          }
        } catch (e) { /* stille fallback — knop houdt z'n statische label */ }
      })
      .catch(function () { /* stil */ });
  }

  if (applyBtn) {
    applyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      apply();
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = window.location.pathname;
    });
  }

  /* Recompute the live count on any mobile filter change (debounced). */
  if (countEl) {
    form.addEventListener('change', function (e) {
      if (!mq.matches) return;
      if (e.target && e.target.name === 'sort_by') return;
      clearTimeout(countDebounce);
      countDebounce = setTimeout(updateCount, 300);
    });
    /* Seed the count when the drawer opens. */
    var openBtn = document.getElementById('mobile-filters-open');
    if (openBtn) openBtn.addEventListener('click', updateCount);
  }
})();
